const QUESTIONNAIRE_COLORS = ["#7F56D9", "#3B82F6", "#10B981", "#F59E0B"];

function formatDecimal(value) {
  if (value == null || !Number.isFinite(Number(value))) {
    return "–";
  }
  return Number(value).toFixed(1).replace(".", ",");
}

function formatPercentage(value) {
  if (value == null || !Number.isFinite(Number(value))) {
    return "–";
  }
  return `${Number(value).toFixed(1).replace(".", ",")}%`;
}

function groupByIssue(rows = []) {
  const groups = [];
  rows.forEach((row) => {
    const last = groups[groups.length - 1];
    if (!last || last.issue !== row.issue) {
      groups.push({ issue: row.issue, year: row.year, quarter: row.quarter, rows: [row] });
    } else {
      last.rows.push(row);
    }
  });
  return groups;
}

export default function LoonOpZandComparisonTab({ data }) {
  if (!data) {
    return null;
  }

  const questionnaires = data.questionnaires || [];
  const responseGroups = groupByIssue(data.response_rows || []);
  const scoreGroups = groupByIssue(data.score_rows || []);
  const scoreByQuestionnaireYear = new Map(
    (data.questionnaire_year_scores || []).map((row) => [
      `${row.year}-${row.questionnaire}`,
      row,
    ])
  );

  return (
    <div className="loonopzand-dashboard__comparison">
      <section className="chart-card loonopzand-dashboard__comparison-card">
        <header className="chart-card__header">
          <div>
            <h3 className="chart-title">Responspercentage</h3>
            <p className="loonopzand-dashboard__score-subtitle">
              Responses uit de database ten opzichte van het aantal aangeschreven inwoners.
            </p>
          </div>
        </header>
        <div className="loonopzand-dashboard__comparison-table-wrap">
          <table className="loonopzand-dashboard__comparison-table">
            <thead>
              <tr>
                <th>Jaar</th>
                <th>Kwartaal</th>
                <th>Vragenlijst</th>
                <th>Respondenten</th>
                <th>Aangeschreven</th>
                <th>Respons</th>
              </tr>
            </thead>
            <tbody>
              {responseGroups.flatMap((group) =>
                group.rows.map((row, index) => (
                  <tr key={`${row.issue}-${row.questionnaire}`}>
                    <td>{index === 0 ? group.year : ""}</td>
                    <td>{index === 0 ? `Q${group.quarter}` : ""}</td>
                    <td>{row.label}</td>
                    <td>{row.response_count}</td>
                    <td>{row.invited_count ?? "–"}</td>
                    <td>{formatPercentage(row.response_percentage)}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
        <p className="loonopzand-dashboard__comparison-note">
          Voor periodes zonder aangeleverd aantal aangeschreven inwoners wordt geen
          responspercentage berekend.
        </p>
      </section>

      <section className="chart-card loonopzand-dashboard__comparison-card">
        <header className="chart-card__header">
          <div>
            <h3 className="chart-title">Rapportcijfers</h3>
            <p className="loonopzand-dashboard__score-subtitle">
              Gewogen gemiddelden over alle geldige rapportcijfers in de database.
            </p>
          </div>
        </header>

        <div className="loonopzand-dashboard__comparison-year-averages">
          {(data.yearly_scores || []).map((row, index) => (
            <div
              key={row.year}
              className="loonopzand-dashboard__comparison-year-average"
              style={{ "--comparison-color": QUESTIONNAIRE_COLORS[index % QUESTIONNAIRE_COLORS.length] }}
            >
              <span>{row.year}</span>
              <strong>{formatDecimal(row.average)}</strong>
              <small>{row.answered_count} rapportcijfers</small>
            </div>
          ))}
        </div>

        <div className="loonopzand-dashboard__comparison-table-wrap">
          <table className="loonopzand-dashboard__comparison-table loonopzand-dashboard__comparison-table--scores">
            <thead>
              <tr>
                <th>Jaar</th>
                {questionnaires.map((questionnaire) => (
                  <th key={questionnaire.slug}>{questionnaire.label}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {(data.yearly_scores || []).map((yearRow) => (
                <tr key={yearRow.year}>
                  <th>{yearRow.year}</th>
                  {questionnaires.map((questionnaire) => {
                    const row = scoreByQuestionnaireYear.get(
                      `${yearRow.year}-${questionnaire.slug}`
                    );
                    return <td key={questionnaire.slug}>{formatDecimal(row?.average)}</td>;
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <h4 className="loonopzand-dashboard__comparison-subheading">
          Rapportcijfer per periode
        </h4>
        <div className="loonopzand-dashboard__comparison-table-wrap">
          <table className="loonopzand-dashboard__comparison-table">
            <thead>
              <tr>
                <th>Jaar</th>
                <th>Kwartaal</th>
                <th>Vragenlijst</th>
                <th>Gemiddelde</th>
                <th>Aantal cijfers</th>
              </tr>
            </thead>
            <tbody>
              {scoreGroups.flatMap((group) =>
                group.rows.map((row, index) => (
                  <tr key={`${row.issue}-${row.questionnaire}`}>
                    <td>{index === 0 ? group.year : ""}</td>
                    <td>{index === 0 ? `Q${group.quarter}` : ""}</td>
                    <td>{row.label}</td>
                    <td>{formatDecimal(row.average)}</td>
                    <td>{row.answered_count}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
}
